import { Cookies } from 'react-cookie';
import { ADD_TO_HOME_SCREEN_POP_UP_COOKIE_NAME } from '../../config/index';

export const setHideAddToHomeScreenPopUpCookie = (hide: any) =>
  new Cookies().set(ADD_TO_HOME_SCREEN_POP_UP_COOKIE_NAME, hide, {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'setYear' does not exist on type 'Date'.
    expires: new Date(new Date().setYear(2099)),
    path: '/',
  });
